import { useState, React } from "react";
import "../css/About.css";
import "../css/Service.css";
import { Navigation, Autoplay, Pagination } from "swiper";
// Import Swiper styles
import $ from 'jquery';
import Modal from "react-bootstrap/Modal";
import { MetaTags } from "react-meta-tags";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import Footer from "./Footer";

import cake from '../images/express/cake3.jpg';
import dish1 from '../images/express/wedding1.jpg';
import dish2 from '../images/express/wed2.jpg';
import dish3 from '../images/express/cake4.jpg';
import dish4 from '../images/express/N.JPG';
import dish5 from '../images/express/cake5.jpg';
import decor1 from '../images/express/show1.jpg';
import decor2 from '../images/express/show2.jpg';
import decor3 from '../images/express/show3.jpg';
import decor4 from '../images/express/show4.jpg';
import decor5 from '../images/express/show5.jpg';
import decor6 from '../images/express/A (1).JPG';
import decor7 from '../images/express/decor1.jpg';
import decor8 from '../images/express/decor2.jpg';
import decor9 from '../images/express/food-count.jpg';
import decor10 from '../images/express/buff2.jpg';
// import aboutpic from "../images/download (1).jpg";

const Service = () => {
  const formSubmit = () => {
    var custName;
    var custEmail;
    var custPhone;
    var custAge;
    var custMessage;

    if ($("#custName").val() !== "") {
      custName = $("#custName").val();
    } else {
    }
    if ($("#custPhone").val() !== "") {
      custPhone = $("#custPhone").val();
    } else {
    }
   
    if ($("#custEmail").val() !== "") {
      custEmail = $("#custEmail").val();
    } else {
    }

    if ($("#custMessage").val() !== "") {
      custMessage = $("#custMessage").val();
    } else {
    }
    
    var body =
      '<!DOCTYPE html><html><head><title>The Express Caterers</title><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><meta http-equiv="X-UA-Compatible" content="IE=edge"></head><body style="margin:0!important;padding:0!important;background-color:#eee" bgcolor="#eeeeee"><div style="display:none;font-size:1px;color:#fefefe;line-height:1px;font-family:Open Sans,Helvetica,Arial,sans-serif;max-height:0;max-width:0;opacity:0;overflow:hidden"></div><table border="0" cellpadding="0" cellspacing="0" width="100%" bgcolor="#fff"><tr><td align="center" style="background-color:#eee" bgcolor="#eeeeee"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td align="center" valign="top" style="font-size:0;padding:10px" bgcolor="#e56f35"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:6px;font-weight:800;line-height:10px" class="mobile-center"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;line-height:24px;padding:10px"><a href="tel:+91" style="text-decoration:none;color:#fff;font-family:serif;font-size:16px">Leads Generate for The Express Caterers</a></td></tr></table></td></tr></table></div></td></tr><tr><td align="center" valign="top" style="font-size:0;padding:15px" bgcolor="#fff"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:36px;font-weight:800;line-height:48px" class="mobile-center"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"><tr><td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-weight:800"><img style="width:120px;height:120px" src="" alt=""></td></tr></table></td></tr></table></div></td></tr><tr><td align="center" valign="top" style="font-size:0;padding:0" bgcolor="#e56f35"><div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"><tr><td width="100%" align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;padding:10px 0" class="mobile-center"><h1 style="text-transform:capitalize;font-size:14px;font-weight:500;margin:0;text-align:center;color:#fff">Client Enquiry Details</h1></td></tr></table></div></td></tr><tr><td align="center" height="100%" valign="top" width="100%" style="padding:0 35px 35px 35px;background-color:#fff" bgcolor="#eee"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:660px"><tr><td width="100%" align="center" valign="top" style="font-size:0"><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;text-align:center;width:100%"><table width="100%" align="center" border="0" cellpadding="0" cellspacing="0" style="max-width:300px"><tr><td width="100%" align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#e56f35">Customer Name:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custName +
      '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td width="100%" align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#e56f35">Customer Number:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custPhone +
      '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#164388">Customer Email:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custEmail +
      '</p></td></tr></table></div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"><tr><td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"><p style="font-size:16px;font-weight:600;color:#164388">Customer Message:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custMessage +
      '</p></td></tr></table></div></td></tr></table></td></tr><tr><td width="100%" align="center" bgcolor="#e56f35" style="padding:10px 0"><p style="color:#fff;font-weight:500;font-size:1rem;padding:0;margin:0">© Copyright 2023 The Express Caterers</p></td></tr></table></td></tr></table></body></html>';

    $.post(
      "https://skdm.in/server/v1/send_lead_mail.php",
      {
        
        toEmail: "theexpresscaterers@gmail.com",
        fromEmail: "skdmlead@gmail.com",
        bccMail: "skdmlead@gmail.com",
        mailSubject: "New Lead genration",
        mailBody: body,
        accountName: "Express cater",
        accountLeadSource: "http://sundarfarms.com/",
        accountLeadName: custName,
        accountLeadPhone: custPhone,
        accountLeadEmail: custEmail,
        accountLeadMsgs: custMessage,
      },

      function (dataa, status) {
        console.log("data :" + dataa);
        console.log("name:" + custName);
      }
    );

    alert("Your Form has Submited Our team will contact with You  soon.");

    window.location.reload();

    return false;
  };
const [show, setShow] = useState(false);
const handleClose = () => setShow(false);

const handleShow = () => setShow(true);
  return (
    <>
     {/* --------------------------------seo start--------------------------------- */}
     <MetaTags>
        <title>
          {" "}
          Best Caterers in Dahisar | The Express Caters
        </title>
        <meta name="google-site-verification" content="7SedB4wBTSXQ-5jGmNcsjt5cV7hPKrgS31utL8lPh3c" />
        <meta
          name="description"
          content="Elevate your events with the Best Caterers in Dahisar. Our expert catering services in Dahisar ensure  making your occasions truly unforgettable. "
        />
        <meta
          name="keywords"
          content="Caterers in Dahisar,
          Wedding Caterers in Dahisar,
          Best Cateres In Dahisar,
          Party Cateres In Dahisar,
          Best food Cateres In Dahisar"
        />
        <meta
          property="og:title"
          content="Best Caterers in Dahisar | The Express Caters"
        />
        <meta
          property="og:description"
          content="Elevate your events with the Best Caterers in Dahisar. Our expert catering services in Dahisar ensure  making your occasions truly unforgettable. "
        />
        <link
          rel="canonical"
          href="https://theexpresscaterers.in/best-caterers-in-dahisar"
        />

<meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content="Best Caterers in Dahisar | The Express Caters" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://theexpresscaterers.in/" />
        <meta property="og:description" 
        content="Elevate your events with the Best Caterers in Dahisar. Our expert catering services in Dahisar ensure  making your occasions truly unforgettable. " />

      </MetaTags>
       {/* --------------------------------seo end--------------------------------- */}

      <section className="servicetop  mt-2" id=" ">
        <div className="container">
          <div className="row d-flex justify-content-center ">
            <div className="col-md-6"></div>

            <div className="col-md-6">
              <div className="innovDetail">
                <h1>Best Caterers in Dahisar </h1>
                <p>We are the best caterers in Dahisar, At ‘The Express Caterers” we emphasize more on the quality of food and service catering to every occasion, be it elaborate or intimate, our expert team of chefs and servers ensure perfection from choosing the right menu preparation, to execution and service makes us the best caterers in dahisar. Their infrastructure, expertise & experience give them a unique range & range of sparkling ideas. . We are a team of professional caterers serving the catering needs of weddings, corporate, outdoor, small parties, and more. Our catering solutions are tailored and designed to meet what you are looking for and what to create to inspire an exciting catering experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="p-lg-5">
        <div class="container">
          <div className="titleSection">
            <span>Service</span>
            <h2>Planning A Fabulous Event</h2>
            {/* <p>
            Lorem Ipsum has been the industry's standard dummy text ever since
            the 1500s, when an unknown printer took a galley of type and
            scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic
            typesetting, remaining essentially unchanged.
          </p> */}
          </div>
          <div class="row   rowDesign">
            <div class="col-lg-6 col-12">
              <div class="slist">
                <div class="row">
                  <div class="col-12 d-flex Service1">
                    <div class="sdetail">
                      <span>Weddings</span>
                      <p>
                      WEDDINGS
Weddings are perhaps the biggest day of one’s life, and hence we strive our best to make it truly unforgettable. Right from gorgeous banquets, delicious and creative cuisines to warm & attentive service, The Express Caterer is the best caterers in dahisar who always goes the extra mile.
  </p>
                    </div>
                    <div class="snum">
                      <h2>01</h2>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div class="col-lg-6 col-12">
              <div class="slist-right">
                <div class="row">
                  <div class="col-12 d-flex Service2">
                    <div class="snum">
                      <h2>02</h2>
                    </div>
                    <div class="sdetail">
                      <span>Institutes</span>
                      <p>
                      We also cater to institutions and schools; we design wholesome and delicious meals keeping in mind the special nutritional requirements of students. We assure you with hygienic, healthy and delicious food for the school students.
     </p>
                    </div>

                  </div>
                </div>
              </div>
              </div>
              <div class="col-lg-6 col-12">
              <div class="slist">
                <div class="row">
                  <div class="col-12 d-flex">
                    <div class="sdetail">
                      <span>Corporate</span>
                      <p>
                      Elegant and formal corporate events require a good knowledge of the kind of cuisines that suit the occasion. Also, the presentation of the food is equally important. The Express Caterers excel in both these areas, with our high-quality food and professional presentations winning the hearts of multiple Corporate clients!


                      </p>
                    </div>
                    <div class="snum">
                      <h2>03</h2>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div class="col-lg-6 col-12">
              <div class="slist-right">
                <div class="row">
                  <div class="col-12 d-flex">
                    <div class="snum">
                      <h2>04</h2>
                    </div>
                    <div class="sdetail">
                      <span>Ethnic Food Festivals</span>
                      <p>
                      One of the major things to explore in every destination is its food! The type of cuisine changes every few hundred miles, offering something diverse and all the more finger licking on your platter every time. With these stupendous ethnic food festivals to fill your bellies with your favorite culinary delights and offering something unique, they are nothing less than a heaven for foodies across the world. It’s time to let your unconditional love for food do the talking and ditch those useless Diet Goals.
 </p>
                    </div>

                  </div>
                </div>
              </div>
              </div>
              <div class="col-lg-6 col-12">
              <div class="slist">
                <div class="row">
                  <div class="col-12 d-flex Service1">
                    <div class="sdetail">
                      <span>Socials</span>
                      <p>
                      Celebrations begin with social gatherings and happy social gatherings are always a matter of great food! As the caterers of choice in multiple such gatherings, The Express Caterers has concocted various delicious dishes to suit the specific palates of the guests and served with politeness - with quality always at the forefront!
</p>
                    </div>
                    <div class="snum">
                      <h2>05</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div class="col-md-4 col-12">
              <div class="simg"></div>
            </div> */}
           
              
              <div class="col-lg-6 col-12">
              <div class="slist-right">
                <div class="row">
                  <div class="col-12 d-flex Service2">
                    <div class="snum">
                      <h2>06</h2>
                    </div>
                    <div class="sdetail">
                      <span>Private Parties</span>
                      <p>
                      Thanks to our creative insight into cuisines; The Express Caterers is often the first choice when it comes to lavish private parties. Our prime goal is to ensure your guests leave with a wide smile on their faces. We have designed our food as per the unique themes of such parties and have always come out with flying colors!
 </p>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="bookSection mt-lg-5 mt-2 mb-lg-5 mb-2pt-lg-5 pt-2" id="">

        <div class="titleSection ">
          <span>
            BOOK TODAY!
          </span>
          <h2>   We also provide food by the kilos  <br /> 
          For any kind of Event
        </h2>
          <button data-bs-toggle="modal"
        data-bs-target="#exampleModal"
        onClick={handleShow}  class="bookBtn">
            <h3>Book Now</h3>
          </button>
        </div>




      </section>
      <section className="luxurious">
        <div className="container">
          <div className="titleSection">
            <span>
              Food Gallery
            </span>
            <h2>View Our latest Projects</h2>
            <p>
            We are a team of professional caterers serving the catering needs of weddings, corporate, outdoor, small parties, and more. We understand well that the type of event will determine the type of services you need. Our catering solutions are tailored and designed to meet what you are looking for and what to create to inspire an exciting catering experience.
            </p>
          </div>

          <div className="Demo">
            <Swiper
              slidesPerView={3}
              spaceBetween={30}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              modules={[Autoplay, Pagination]}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                640: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                },
              }}
              pagination={{
                clickable: true,
              }}
              className="mySwiper"
            >
              <SwiperSlide>
                <div class="cardImg">
                  <img src={cake} alt="decorative cakes"/>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={dish1} alt="stage decoration"/>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={dish2} alt="stage decoration" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={dish3} alt="wedding cake"/>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={dish4} alt="continental food "/>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={dish5} alt="anniversary cake" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={decor1} alt="catering presentation"/>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={decor2} alt="roti counter" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={decor3} alt="plate counter"/>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={decor4} alt="crockery" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={decor5} alt="food items"/>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={decor6} alt="salad decoration" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={decor7} alt="amazing food"/>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={decor8} alt="experienced chefs"/>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={decor9} alt="happy client"/>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="cardImg">
                  <img src={decor10} alt="happy clients"/>
                </div>
              </SwiperSlide>
            </Swiper>

          </div>




          {/*  */}
        </div>
      </section>
      <Modal
        show={show}
        id="exampleModal"
        backdrop="static"
        keyboard={false}
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        onHide={handleClose}
      >
        <Modal.Body>
          <div className="partnerProgramForm">
            <div className="formTitleSection">
              <div className="modal-content">
                <div className="modal-header ml-5">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Enquiry Now
                  </h5>
                  <div
                    className="closeProgram closeProgram1"
                    onClick={handleClose}
                  >
                    {" "}
                    <i className="fa fa-times" />{" "}
                  </div>
                </div>
                <div className="modal-body">
                  <div className="col-lg-12">
                    <form
                      action=""
                      // method="post"
                      // role="form"
                      // className="php-email-form"
                    >
                      <div className="row">
                        <div className="col-md-6 form-group">
                          <input
                            type="text"
                            name="name"
                            className="form-control input1"
                            id="custName"
                            placeholder="Your Name"
                            required=""
                          />
                        </div>
                        <div className="col-md-6 form-group mt-3 mt-md-0">
                          <input
                            type="number"
                            className="form-control input1"
                            name="phone"
                            id="custPhone"
                            placeholder="Your Phone No"
                            required=""
                          />
                        </div>
                      </div>
                      <div className="form-group mt-3">
                        <input
                          type="email"
                          className="form-control input1"
                          name="email"
                          id="custEmail"
                          placeholder="Your Email"
                          required=""
                        />
                      </div>
                      <div className="form-group mt-3">
                        <textarea
                          className="form-control input1"
                          name="message"
                          id="custMessage"
                          rows={6}
                          placeholder="Message"
                          required=""
                          defaultValue={""}
                        />
                      </div>
                      {/* <div className="my-3">
          <div className="loading">Loading</div>
          <div className="error-message" />
          <div className="sent-message">
            Your message has been sent. Thank you!
          </div>
        </div> */}
                      <div className="text-center submitTarget">
                        <button type="submit" onClick={formSubmit}>
                          Send Message
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Footer />
    </>
  );
};

export default Service;
